export default function getIcon(id) {
  return this.$store.getters.getIconById(id);
}
